/**
 * RESPONSIBILITY: the closing "new here" band on the home page.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.HomeVisit, label: 'Home · New here' })
export class HomeVisitSection {
  @Text({
    label: 'Subtitle', maxLength: 120, default: 'First time?',
    description: 'The small line above the title.',
  })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 300, default: 'New here' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 3 })
  body!: string;

  @Text({ label: 'First button text', maxLength: 120, default: 'Plan a visit', group: 'Buttons' })
  ctaLabel!: string;
  @Link({ label: 'First button link', group: 'Buttons', description: LINK_HINT })
  ctaHref!: string;
  @Text({ label: 'Second button text', maxLength: 120, default: 'Contact us', group: 'Buttons' })
  altLabel!: string;
  @Link({ label: 'Second button link', group: 'Buttons', description: LINK_HINT })
  altHref!: string;
}
